import { render } from "./Pay_Groups.vue?vue&type=template&id=9b80644a"
import script from "./Pay_Groups.vue?vue&type=script&lang=js"
export * from "./Pay_Groups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__